import Menu from './Menu'

export default function Adminmenu() {
    return (<Menu items={[
        ['/admin/offers', 'faBox', 'Ofertas'],
        ['/admin/clients', 'faUsers', 'Clientes'],
        ['/admin/transactions', 'faHandHoldingDollar', 'Transacciones']
    ]} />)
}